export default "__VITE_ASSET__CkZZn8gS__"